import { FormBuilder, Validators } from '@angular/forms';
var TeamFormComponent = /** @class */ (function () {
    function TeamFormComponent(formBuilder) {
        this.formBuilder = formBuilder;
        /**
         * Informs if loading is active or not
         */
        this.isLoading = false;
        this.createForm();
    }
    /**
     * Data selection action by clicking the form submit button
     */
    TeamFormComponent.prototype.doSubmit = function () {
        this.modal.close({
            action: 'save',
            form: 'team',
            formData: this.teamForm.value
        });
    };
    Object.defineProperty(TeamFormComponent.prototype, "f", {
        /**
         *  Getter to access the form fields
         *
         *  @return AbstractControl
         */
        get: function () {
            return this.teamForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Form creation and validation configuration
     */
    TeamFormComponent.prototype.createForm = function () {
        this.teamForm = this.formBuilder.group({
            name: ['', Validators.required]
        });
    };
    return TeamFormComponent;
}());
export { TeamFormComponent };
